import { fetch } from "@/helpers";

export function getReviewerList(keywords) {
  return fetch.get("/1/reviewers/list", {
    params: {
      current_page: 1,
      per_page: 5000,
      keywords
    }
  });
}

export function getMyPackageList() {
  return fetch
    .get("/1/reviewers/myPackageList")
    .then(res => JSON.parse(res.data.data));
}

export function getMyPackage(reviewer_id) {
  return fetch
    .get(`/1/reviewers/packageList/${reviewer_id}`)
    .then(res => JSON.parse(res.data.data));
}

export function addPackage({ title, description, price }) {
  return fetch.post("/1/reviewers/addPackage", {
    title,
    description,
    price: +price * 100
  });
}

export function updatePackage({ id, title, description, price }) {
  return fetch.post("/1/reviewers/updatePackage", {
    id,
    title,
    description,
    price: +price * 100
  });
}

export function updateAvailableSchedule(time) {
  return fetch.post(
    "/1/reviewers/updateAvailableSchedule",
    {
      repeat: 2, // weekly repeat
      ...time
    },
    {
      useCustomExceptionReminder: true
    }
  );
}

export function addAvailableSchedule(params) {
  return fetch
    .post(
      "/1/reviewers/addAvailableSchedule",
      {
        repeat: 2, // weekly repeat
        ...params
      },
      {
        useCustomExceptionReminder: true
      }
    )
    .then(res => JSON.parse(res.data.data));
}

export function getReviewerAvailableSchedule() {
  return fetch
    .get("/1/reviewers/getAvailableSchedule")
    .then(res => JSON.parse(res.data.data));
}

export function getPilotAvailableSchedule(reviewerId) {
  return fetch
    .get(`/1/pilots/getAvailableSchedule/${reviewerId}`)
    .then(res => JSON.parse(res.data.data));
}

export function getPackageList(reviewerId) {
  return fetch
    .get(`/1/pilots/packageList/${reviewerId}`)
    .then(res => JSON.parse(res.data.data));
}

export function booking({ start_date, end_date, package_id, reviewer_id }) {
  return fetch.post("/1/pilots/booking", {
    start_date,
    end_date,
    package_id,
    reviewer_id
  });
}

export function bookingUpdate({ id, start_date, end_date }) {
  return fetch.put("/1/pilots/bookingUpdate", {
    id,
    start_date,
    end_date
  });
}

export function findBooking() {
  return fetch
    .get("/1/pilots/findBooking")
    .then(res => JSON.parse(res.data.data));
}

export function getReviewerBookingList({ currentPage, perPage }) {
  return fetch
    .get("/1/reviewers/getBookingPage", {
      params: {
        current_page: currentPage,
        per_page: perPage
      }
    })
    .then(res => JSON.parse(res.data.data));
}

export function updateReviewAddress({
  review_street,
  review_city,
  review_province,
  review_postalcode,
  flight_schools
}) {
  return fetch.put("/1/reviewers/updateReviewAddress", {
    review_street,
    review_city,
    review_province,
    review_postalcode,
    flight_schools
  });
}

export function updateBookingStatus({ id, event_status, description }) {
  return fetch.put("/1/reviewers/updateBookingStatus", {
    id,
    event_status,
    description
  });
}

export function getFlightSchool() {
  return fetch
    .get("/1/reviewers/getFlightSchool")
    .then(res => JSON.parse(res.data.data));
}

export function delAvailableSchedule(id) {
  return fetch.delete("/1/reviewers/delAvailableSchedule", {
    data: {
      id
    }
  });
}

export function getNearTermBookings() {
  return fetch
    .get("/1/reviewers/getNearTermBookings")
    .then(res => JSON.parse(res.data.data));
}

export function getAvaliableEventsByScheduleId(id) {
  return fetch
    .get(`/1/reviewers/getAvaliableEventsByScheduleId/${id}`)
    .then(res => JSON.parse(res.data.data));
}
